/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_CONTRACT,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_LEGAL_INSURANCE,
  APPLICATION_STATUS_PERSONAL,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_SUMMARY,
  APPLICATION_STATUS_TERMINATION,
} from "./applicationStatus";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarSteps from "./progressBarSteps";
import Personal from "@/src/components/Form/Settlement/Personal";
import Termination from "@/src/components/Form/Settlement/Termination";
import PowerOfAttorney from "@/src/components/Form/Settlement/PowerOfAttorney/PowerOfAttorney";
import Documents from "@/src/components/Form/Settlement/Documents";
import SummaryHintBox from "@/src/components/Form/Common/SummaryHintBox";
import Summary from "@/src/components/Form/Settlement/Summary";
import { Navigate } from "react-router";
import { getCaseLink } from "@/src/services/productService";
import Insurance from "@/src/components/Form/Common/Insurance/Insurance";
import Contract from "@/src/components/Form/Settlement/Contract";
import { FormSteps } from "@/src/types/FormServiceBase";
import PowerOfAttorneyHintBox from "@/src/components/Form/Settlement/PowerOfAttorney/PowerOfAttorneyHintBox";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_TERMINATION]: {
    title: "Antrag - Kündigung | Legalbird",
    stepUrl: "kuendigung",
    applicationStatus: APPLICATION_STATUS_TERMINATION,
    render: (props) => (
      <>
        <HintBox headline={"3-Wochen-Frist bei Kündigung - Jetzt Angaben vervollständigen!"}>
          <p>
            Nach Erhalt einer Kündigung können Sie nur 3 Wochen lang gegen diese vorgehen - danach ist die Kündigung immer rechtswirksam! Damit wir innerhalb
            der Frist gegen Ihre Kündigung vorgehen können, benötigen wir schnellstmöglich alle Angaben von Ihnen. Im Anschluss wird alles Weitere in einem
            persönlichen Telefonat besprochen.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarSteps} active={"contractTermination"} progress={16} />
        <Termination {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT]: {
    title: "Antrag - Arbeitsverhältnis | Legalbird",
    stepUrl: "arbeitsverhaeltnis",
    applicationStatus: APPLICATION_STATUS_CONTRACT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"contract"} progress={48} />
        <Contract {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_LEGAL_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    stepUrl: "versicherung",
    applicationStatus: APPLICATION_STATUS_LEGAL_INSURANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"personal"} progress={66} />
        <Insurance {...props} withDeductible />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL]: {
    title: "Antrag - Ihre Angaben | Legalbird",
    stepUrl: "ihre-angaben",
    applicationStatus: APPLICATION_STATUS_PERSONAL,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"personal"} progress={66} />
        <Personal {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    stepUrl: "ueberpruefen",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: {
    title: "Antrag - Vollmacht | Legalbird",
    stepUrl: "vollmacht",
    applicationStatus: APPLICATION_STATUS_POWER_OF_ATTORNEY,
    render: (props) => (
      <>
        <PowerOfAttorneyHintBox product={props.product} />
        <PowerOfAttorney {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente hochladen | Legalbird",
    stepUrl: "dokumente-hochladen",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    render: (props) => (
      <>
        <HintBox headline={"Dokumente hochladen"}>
          <p>Laden Sie hier bitte Ihren Arbeitsvertrag und das Kündigungsschreiben hoch, damit wir Ihre Kündigung unverbindlich prüfen können.</p>
        </HintBox>
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DONE]: {
    title: "Meine Abfindung | Legalbird",
    stepUrl: "",
    applicationStatus: APPLICATION_STATUS_DONE,
    render: (props) => <Navigate to={getCaseLink(props.product)} />,
  },
};

export default formSteps;
